<template>
  <div class="vt-custom-modal-header mb-3">
    <span>
      <slot />
    </span>
  </div>
</template>

<script>
export default {
    name: 'CustomModalHeader'
}
</script>

<style lang="scss" scoped>
.vt-custom-modal-header {
  font-size: font-size(normal);
  color: vt-color(gray);
  padding: 15px 29px 15px 24.8px;
  border-bottom: 1px solid vt-color(light-grey-alt);
  margin-top: -0.5rem;
  margin-right: -0.75rem;
  margin-left: -0.75rem;
}
</style>
